<template>
  <div class="appbar-wrap">
    <div ref="appbar" class="appbar">
      <div class="appbar-content">
        <div class="appbar-content-left">
          <a href="/">
            <img
              class="appbar-logo"
              :src="require('@/assets/home/home-top-log.png')"
              alt=""
            />
          </a>
          <div class="menu-dropdown-wrap" @mouseleave="onMouseleve">
            <div
              v-for="(menuItem, menuIndex) in menuList"
              :key="menuIndex"
              ref="menuItem"
              class="menu-item"
              :class="{'mouseIn': mouseOn == menuIndex}"
              @mouseenter="onMouseenter(menuItem,menuIndex)"
              @click="routerJump(menuItem)"
            >
              <div class="menu-item-text">
                {{ menuItem.title }}
              </div>
              <div
                v-if="menuIndex === 2 || menuIndex === 3"
                :ref="'downWrap' + menuIndex"
                class="dropdown-wrap"
              >
                <div :ref="'dropDown'+menuIndex" class="dropDown-content">
                  <div
                    v-for="(item, index) in menuItem.childList"
                    :key="index"
                    class="dropDown-item"
                    @click="routerJump(item, menuIndex)"
                  >
                    <img :src="item.icon" alt="" class="content-icon" />
                    <div class="content-title-subtitle">
                      <div class="content-title">{{ item.title }}</div>
                      <div v-if="item.subtitle != ''" class="content-subtitle">
                        {{ item.subtitle }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else-if="menuIndex === 4"
                :ref="'downWrap' + menuIndex"
                class="dropdown4"
              >
                <div :ref="'dropDown' + menuIndex" class="dropDown-content">
                  <div
                    v-for="(item, index) in menuItem.childList"
                    :key="index"
                    class="dropDown-List-item"
                  >
                    <div class="item-title">{{ item.title }}</div>
                    <div class="item-zhong">
                      <div
                        v-for="(viewItem, viewIndex) in item.viewList"
                        :key="viewIndex"
                        class="viewItem"
                        @click="routerJump(viewItem, menuIndex)"
                      >
                        <img :src="viewItem.icon" alt="" class="content-icon" />
                        <div class="content-title-subtitle">
                          <div class="content-title">{{ viewItem.title }}</div>
                          <div v-if="viewItem.subtitle != ''" class="content-subtitle">
                            {{ viewItem.subtitle }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="dropDown" class="dropdown-container" :style="{height: downHeight+'px'}">
              <div
                v-for="(menuItem, menuIndex) in menuList"
                :key="menuIndex"
                ref="dropDownContent"
                class="drop-content"
                @mouseenter="mouseOn = menuIndex"
                @mouseleave="mouseOn = null"
              >
                <div
                  v-for="(item, index) in menuItem.childList"
                  :key="index"
                  class="content-item"
                  @click="routerJump(item, menuIndex)"
                >
                  <img :src="item.icon" alt="" class="content-icon" />
                  <div class="content-title-subtitle">
                    <div class="content-title">{{ item.title }}</div>
                    <div v-if="item.subtitle != ''" class="content-subtitle">
                      {{ item.subtitle }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="appbar-content-right">
          <a href="http://120.76.77.155:8055/" target="_blank">
            <div class="service-centre">
              <img :src="require('@/assets/icon/service.png')" alt="" class="service-icon" />
              <div class="txt">服务中心</div>
            </div>
          </a>
          <div class="phone-wrap">
            <div class="phone-icon-wrap">
              <img :src="require('@/assets/icon/phone.png')" alt="" class="phone-icon" />
            </div>
            <div class="phone-txt" v-html="Hotline"></div>
          </div>
          <!-- <img class="phone-ico" :src="require('@/assets/home/phone-icon.png')" alt="" />
          <div>
            <div>400-138-258</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getVariableInfo } from '@/api/variable';
import staffManage from '@/assets/icon/staff_manage.png';
import workingHours from '@/assets/icon/working_hours.png';
import payWelfare from '@/assets/icon/pay_welfare.png';
import personnelGrow from '@/assets/icon/personnel_grow.png';
import personnelRecruit from '@/assets/icon/personnel_recruit.png';
import achievements from '@/assets/icon/achievements.png';
import development from '@/assets/icon/development.png';
import cloudPlatform from '@/assets/icon/cloud_platform.png';
import mobile from '@/assets/icon/mobile.png';
import hardware from '@/assets/icon/hardware.png';
import electronics from '@/assets/icon/electronics.png';
import integrated from '@/assets/icon/integrated.png';
import food from '@/assets/icon/food.png';
import download from '@/assets/icon/download.png';
import experience from '@/assets/icon/experience.png';
import intelligent from '@/assets/icon/intelligent.png';
import profile from '@/assets/icon/profile.png';
import history from '@/assets/icon/history.png';
import culture from '@/assets/icon/culture.png';
// import values from '@/assets/icon/values.png';
import businessSchool from '@/assets/icon/business-school.png';
import wiki from '@/assets/icon/wiki.png';
import huayueInfo from '@/assets/icon/huayue-info.png';
import industryInfo from '@/assets/icon/industry-info.png';
import contactUs from '@/assets/icon/contactUs.png'
import strategyOrganize from '@/assets/icon/strategy_organize.png';
import recruitment from '@/assets/icon/recruitment.png';
import pieceRateSalary from '@/assets/icon/piece-rate-salary.png';
import assessMent from '@/assets/icon/assessment.png';
import talentReview from '@/assets/icon/talent-review.png';
import targetDecomposition from '@/assets/icon/target-decomposition.png';
import virtualOrganization from '@/assets/icon/virtual-organization.png';
export default {
  name: 'AppBar',
  data () {
    return {
      menuList: [
        {
          id: 1,
          title: '核心产品',
          router: '',
          childList: [
            {
              title: '战略组织',
              icon: strategyOrganize,
              subtitle: '适应于企业组织的定义和调整',
              router: '/strategyorganize',
            },
            {
              title: '员工管理',
              icon: staffManage,
              subtitle: '智能化事务处理模式 解放操作员双手',
              router: '/staffmanage',
            },
            {
              title: '考勤工时',
              icon: workingHours,
              subtitle: '智能排班与员工自助的考勤工时管理',
              router: '/workinghours',
            },
            {
              title: '薪酬福利',
              icon: payWelfare,
              subtitle: '一键式薪酬核算与薪资预算管理',
              router: '/paywelfare',
            },
            {
              title: '人才招聘',
              icon: personnelRecruit,
              subtitle: '建立人才储备机制，形成人才梯队管理',
              router: '/personnelrecruit',
            },
            {
              title: '人才培育',
              icon: personnelGrow,
              subtitle: '三大培训体系，赋能企业人才培养',
              router: '/personnelgrow',
            },
            {
              title: '绩效激励',
              icon: achievements,
              subtitle: '与企业战略目标绑定，提高企业竞争力',
              router: '/achievementview',
            },
            {
              title: '人才发展',
              icon: development,
              subtitle: '打造企业数字化人才发展管理模式',
              router: '/development',
            },
          ],
        },
        {
          id: 2,
          title: '解决方案',
          router: '',
          childList: [
            {
              title: '数字化云平台',
              icon: cloudPlatform,
              subtitle: '全方位数字化人才治理平台',
              router: '/cloudplatform',
            },
            {
              title: '对外招聘',
              icon: recruitment,
              subtitle: '让企业实现智能、便捷的招聘模式',
              router: '/recruitment',
            },
            {
              title: '计件薪酬',
              icon: pieceRateSalary,
              subtitle: '智能薪酬计算与合理分配',
              router: '/pieceratesalary',
            },
            {
              title: '人才测评',
              icon: assessMent,
              subtitle: '多维度识别人才，实现“人、岗”精准匹配',
              router: '/assessment',
            },
            {
              title: '人才盘点',
              icon: talentReview,
              subtitle: '帮助企业实现人才精细化分析',
              router: '/talentreview',
            },
            {
              title: '绩效目标分解',
              icon: targetDecomposition,
              subtitle: '逐级分解经营目标',
              router: '/targetdecomposition',
            },
            {
              title: '虚拟组织',
              icon: virtualOrganization,
              subtitle: '结合内部优势资源，强化协同组织',
              router: '/virtualorganization',
            },
            {
              title: '移动端',
              icon: mobile,
              subtitle: '提高线上审批提升工作效率',
              router: '/mobileterminal',
            },
          ],
        },
        {
          id: 3,
          title: '客户案例',
          router: '/customercase',
          childList: [
            {
              title: '上市企业',
              icon: integrated,
              subtitle: '',
              router: '/customercase',
            },
            {
              title: '五金行业',
              icon: hardware,
              subtitle: '',
              router: '/customercase',
            },
            {
              title: '电子电器',
              icon: electronics,
              subtitle: '',
              router: '/customercase',
            },
            {
              title: '食品行业',
              icon: food,
              subtitle: '',
              router: '/customercase',
            },
          ],
        },
        {
          id: 4,
          title: '内容中心',
          router: '',
          childList: [
            {
              title: '软件下载',
              icon: download,
              subtitle: '',
              router: '/software',
            },
            {
              title: '产品体验',
              icon: experience,
              subtitle: '',
              router: '/experience',
            },
            // {
            //   title: '智能自助',
            //   icon: intelligent,
            //   subtitle: '',
            //   router: '/mobileterminal',
            // },
          ],
        },
        {
          id: 5,
          title: '关于华跃',
          router: '',
          childList: [
            {
              title: '了解华跃',
              viewList: [
                {
                  title: '公司介绍',
                  icon: profile,
                  subtitle: '',
                  router: '/about/infroduction',
                },
                {
                  title: '华跃商学院',
                  icon: businessSchool,
                  subtitle: '',
                  router: '/about/business',
                },
                {
                  title: '发展历程',
                  icon: history,
                  subtitle: '',
                  router: '/about/hisory',
                },
                {
                  title: '企业文化',
                  icon: culture,
                  subtitle: '',
                  router: '/about/culture',
                },
                // {
                //   title: '核心价值观',
                //   icon: values,
                //   subtitle: '',
                //   router: '/about/values',
                // },
                {
                  title: '华跃百科',
                  icon: wiki,
                  subtitle: '',
                  router: 'https://baike.baidu.com/item/%E4%BD%9B%E5%B1%B1%E5%B8%82%E5%8D%8E%E8%B7%83%E8%AE%A1%E7%AE%97%E6%9C%BA%E7%B3%BB%E7%BB%9F%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/51448824?fr=ge_ala',
                },
              ],
            },
            {
              title: '新闻中心',
              viewList: [
                {
                  title: '华跃资讯',
                  icon: huayueInfo,
                  subtitle: '',
                  router: '/news/huayue',
                },
                {
                  title: '行业资讯',
                  icon: industryInfo,
                  subtitle: '',
                  router: '/news/industry',
                },
                {
                  title: '联系我们',
                  icon: contactUs,
                  subtitle: '',
                  router: '/news/contactUs'
                },
              ],
            },
          ],
        },
      ],
      mouseOn: null,
      isTop: 0,
      dropDown: true,
      downHeight: 0,
      Height: 0,
      timerout: null,
      Hotline: '',
    };
  },
  mounted () {
    this.getVariable();
    // window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop >= 400 && scrollTop <= 470) {
        this.isTop = 400 - scrollTop;
      } else if (scrollTop < 400) {
        this.isTop = 0;
      } else if (scrollTop > 470) {
        this.isTop = -70;
      }
    },
    getVariable() {
      getVariableInfo({ label: 'Hotline', }).then((res) => {
        const { result, } = res;
        var doc = new DOMParser().parseFromString(result.content, 'text/html');
        this.Hotline = doc.documentElement.textContent.replace(/&nbsp;/g, ' ');
      });
    },
    onMouseenter(item, index) {
      for (var i = 0; i < this.menuList.length; i++) {
        this.$refs.dropDownContent[i].style.display = 'none';
        if (i === 2 || i === 3 || i === 4) {
          this.$refs['downWrap' + i][0].style.height = 0 + 'px';
        }
      }
      if (item.childList.length !== 0 && (index === 0 || index === 1)) {
        this.$refs.dropDownContent[index].style.display = 'flex';
        const demHeight = this.$refs.dropDownContent[index].offsetHeight;
        this.downHeight = demHeight;
        this.Height = 0;
        var m = function(e) { e.preventDefault(); };
        document.getElementById('html').style.overflow = 'hidden';
        document.getElementById('html').style.paddingRight = '15px';
        document.getElementsByClassName('right-fixedgt')[0].style.right = '33px';
        this.$refs.appbar.style.paddingRight = '15px';
        document.addEventListener('touchmove', m, { passive: false, });
      } else if (index === 2 || index === 3 || index === 4) {
        // this.$refs['dropDown' + index][0].style.display = 'flex';
        const demHeight = this.$refs['dropDown' + index][0].offsetHeight;
        this.$refs['downWrap' + index][0].style.height = demHeight + 'px';
        this.downHeight = 0;
        // this.Height = demHeight;
      } else {
        this.dropDown = false;
        if (this.dropDown === false) {
          this.downHeight = 0;
          this.Height = 0;
        }
        var ms = function(e) { e.preventDefault(); };
        document.getElementById('html').style.overflow = '';
        document.getElementById('html').style.paddingRight = '0px';
        document.getElementsByClassName('right-fixedgt')[0].style.right = '18px';
        this.$refs.appbar.style.paddingRight = '0px';
        document.removeEventListener('touchmove', ms, { passive: true, });
        setTimeout(() => {
          this.dropDown = true;
        }, 10);
      }
    },
    onMouseleve() {
      for (var i = 0; i < this.menuList.length; i++) {
        this.$refs.dropDownContent[i].style.display = 'none';
        if (i === 2 || i === 3 || i === 4) {
          this.$refs['downWrap' + i][0].style.height = 0 + 'px';
        }
      }
      this.dropDown = false;
      if (this.dropDown === false) {
        this.downHeight = 0;
      }
      var m = function(e) { e.preventDefault(); };
      document.getElementById('html').style.overflow = '';
      document.getElementById('html').style.paddingRight = '0px';
      document.getElementsByClassName('right-fixedgt')[0].style.right = '18px';
      this.$refs.appbar.style.paddingRight = '0px';
      document.removeEventListener('touchmove', m, { passive: true, });
      setTimeout(() => {
        this.dropDown = true;
      }, 10);
    },
    routerJump(item, menuIndex) {
      if (item.title !== '华跃百科') {
        if (item.router !== '') {
          document.getElementById('html').style.overflow = '';
          document.getElementById('html').style.paddingRight = '0px';
          document.getElementsByClassName('right-fixedgt')[0].style.right = '18px';
          if (menuIndex !== 2) {
            this.$router.push({ path: item.router, });
          } else {
            this.$router.push({ name: 'CustomerCase', params: { label: item.title, }, });
          }
        }
      } else {
        // window.location.href = item.router;
        window.open(item.router, '_blank');
      }
    },
  },
};

</script>

<style>
:root{
  --minwidth: 1200px;
  --appbar-height: 70px;
}
</style>
<style lang="less" scoped>
.appbar-wrap{
  height: 0;
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  .appbar{
    position: absolute;
    width: 100%;
    border-bottom: 1px solid rgba(235,232,232, 0.8);
    backdrop-filter: blur(4px);
    background-color: hsla(0,0%,100%,.8);
    transition: top .2s ease;
    display: flex;
    box-sizing: border-box;
    .appbar-content{
      width: 80%;
      min-width: var(--minwidth);
      height: var(--appbar-height);
      margin: 0 auto;
      // position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .appbar-content-left{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .appbar-logo{
          width: auto;
          height: 40px;
        }
        .menu-dropdown-wrap{
          display: flex;
          align-items: center;
          margin-left: 40px;
          height: 100%;
          .menu-item{
            min-width: 100px;
            height: 100%;
            padding: 0 30px 4px;
            position: relative;
            color: #1c1c1c;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            cursor: default;
            .menu-item-text{
              line-height: 63px;
              border-bottom: 3px solid transparent;
            }
            .dropdown-wrap{
              position: absolute;
              top: 70px;
              left: 0;
              width: 258px;
              height: 0;
              background-color: #fff;
              box-shadow: 0px 20px 12px -12px rgba(150, 166, 195, .25);
              box-sizing: border-box;
              overflow: hidden;
              transition: height .3s ease-in-out;
              .dropDown-content{
                width: 100%;
                display: flex;
                flex-direction: column;
                padding: 20px 10px;
                box-sizing: border-box;
                .dropDown-item{
                  width: 100%;
                  margin-bottom: 10px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  border-radius: 8px;
                  background-color: #fff;
                  padding: 10px;
                  box-sizing: border-box;
                  cursor: pointer;
                  .content-icon{
                    width: 17px;
                    height: auto;
                  }
                  .content-title-subtitle{
                    height: 100%;
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-content: center;
                    margin-left: 8px;
                    .content-title{
                      font-size: 16px;
                      color: #181818;
                      line-height: 1;
                    }
                    .content-subtitle{
                      font-size: 13px;
                      color: #5c6066;
                      line-height: 1;
                      margin-top: 14px;
                    }
                  }
                  &:hover{
                    background: #f5f6f7;
                  }
                }
                .dropDown-item:last-child{
                  margin-bottom: 0;
                }
              }
            }
            .dropdown4{
              position: absolute;
              top: 70px;
              left: -15px;
              width: 656px;
              height: 0;
              background-color: #fff;
              box-shadow: 0px 20px 12px -12px rgba(150, 166, 195, .25);
              box-sizing: border-box;
              overflow: hidden;
              transition: height .3s ease-in-out;
              .dropDown-content{
                width: 100%;
                padding: 40px 40px 20px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                .dropDown-List-item{
                  width: 238px;
                  .item-title{
                    width: 228px;
                    color: #181818;
                    font-family: OPPOSans-R;
                    font-size: 16px;
                    margin-left: 10px;
                    line-height: 1;
                    padding-bottom: 12px;
                    border-bottom: 1px solid #d0d3d8;
                  }
                  .item-zhong{
                    padding-top: 16px;
                    .viewItem{
                      width: 100%;
                      margin-bottom: 10px;
                      display: flex;
                      justify-content: flex-start;
                      align-items: center;
                      border-radius: 8px;
                      background-color: #fff;
                      padding: 10px;
                      box-sizing: border-box;
                      cursor: pointer;
                      .content-icon{
                        width: 20px;
                        height: auto;
                        display: block;
                      }
                      .content-title-subtitle{
                        height: 100%;
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-content: center;
                        margin-left: 8px;
                        .content-title{
                          font-size: 16px;
                          color: #181818;
                          line-height: 1;
                        }
                        .content-subtitle{
                          font-size: 13px;
                          color: #5c6066;
                          line-height: 1;
                          margin-top: 14px;
                        }
                      }
                      &:hover{
                        background: #f5f6f7;
                      }
                    }
                  }
                }
              }
            }
          }
          .mouseIn{
            color: #00b0dc;
            .menu-item-text{
              border-bottom: 3px solid #00b0dc;
            }
          }
          .menu-item:hover{
            color: #00b0dc;
            .menu-item-text{
              border-bottom: 3px solid #00b0dc;
            }
          }
          .dropdown-container{
            position: absolute;
            top: 70px;
            left: 0;
            width: 100vw;
            background-color: #fff;
            overflow: hidden;
            transition: height .3s ease;
            box-shadow: 0px 20px 12px -12px rgba(150, 166, 195, .25);
            border-top: 1px solid rgba(235,232,232, 0.8);
            .drop-content{
              width: 80%;
              min-width: var(--minwidth);
              margin: 0 auto;
              display: none;
              flex-wrap: wrap;
              padding: 20px 0 26px;
              .content-item{
                width: calc(25% - 16px);
                max-height: 62px;
                margin: 0 8px 24px;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                border-radius: 8px;
                background-color: #fff;
                padding: 10px;
                padding-right: 0px;
                box-sizing: border-box;
                cursor:pointer;
                .content-icon{
                  width: 17px;
                  height: auto;
                }
                .content-title-subtitle{
                  height: 100%;
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  align-content: center;
                  margin-left: 8px;
                  .content-title{
                    font-size: 16px;
                    color: #181818;
                    line-height: 1;
                  }
                  .content-subtitle{
                    font-size: 13px;
                    color: #5c6066;
                    line-height: 1;
                    margin-top: 14px;
                  }
                }
              }
              .content-item:hover{
                background-color: #f5f6f7;
              }
            }
          }
        }
      }
      .appbar-content-right{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .service-centre{
          height: 16px;
          display: flex;
          align-items: center;
          border-right: 1px solid #ebe8e8;
          padding-right: 12px;
          cursor: pointer;
          .service-icon{
            width: 18px;
            height: 18px;
            display: block;
            margin-right: 8px;
          }
          .txt{
            font-size: 14px;
            color: #1c1c1c;
            font-family: OPPOSans-R;
          }
        }
        .phone-wrap{
          height: 32px;
          border-radius: 16px;
          // border: 1px solid #e6e6e6;
          // background-color: #fff;
          margin-left: 12px;
          padding: 4px 7px 4px 5px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .phone-icon-wrap{
            width: 24px;
            height: 24px;
            background-color: #e5f8fc;
            border: 1px solid #00b0dc;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            .phone-icon{
              width: 12px;
              height: 12px;
              display: block;
            }
          }
          .phone-txt{
            font-size: 14px;
            color: #1c1c1c;
            font-family: OPPOSans-R;
            margin-left: 7px;
          }
        }
      }
    }
  }
  .appbar:hover{
    background-color: #fff;
  }
}
</style>
